import { useEffect, useState } from 'react';
import $ from 'jquery';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Formation from './components/Formation';
import Projects from './components/Projects';
import Contact from './components/Contact';
import { FiArrowUp } from 'react-icons/fi';
import './App.css';

function App() {
  const [showTop, setShowTop]   = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY;
      const total = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(total > 0 ? (scrolled / total) * 100 : 0);
      setShowTop(scrolled > 400);
    };
    window.addEventListener('scroll', onScroll);

    // Fade-in reveal for sections
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          $(e.target).addClass('revealed');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

    return () => { window.removeEventListener('scroll', onScroll); observer.disconnect(); };
  }, []);

  return (
    <div className="app">
      <div className="scroll-progress" style={{ width: `${progress}%` }} />
      <Navbar />
      <Hero />
      <About />
      <Skills />
      <Formation />
      <Projects />
      <Contact />
      <footer className="footer">
        <p>Designed &amp; Built by <span>Zidane Nait Cheikh</span> · {new Date().getFullYear()}</p>
        <p className="footer-sub">Open to internships &amp; collaborations</p>
      </footer>
      {showTop && (
        <button
          className="back-to-top"
          onClick={() => $('html,body').animate({ scrollTop: 0 }, 600)}
          aria-label="Back to top"
        >
          <FiArrowUp />
        </button>
      )}
    </div>
  );
}

export default App;
